import { render, staticRenderFns } from "./top-section.vue?vue&type=template&id=00bf7926&scoped=true&"
import script from "./top-section.vue?vue&type=script&lang=js&"
export * from "./top-section.vue?vue&type=script&lang=js&"
import style0 from "./top-section.vue?vue&type=style&index=0&id=00bf7926&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bf7926",
  null
  
)

export default component.exports